export default {
  activateLandingPageTitle: 'Evenemang',
  activateProductCardTitle: 'Evenemang',
  activateProductPageTitle: 'Boka evenemang',
  allProductsLandingPageTitle: 'Boka unika upplevelser',
  apply: 'Tillämpa',
  buyTickets: 'Köp biljetter',
  cancel: 'Avbryt',
  clear: 'Rensa',
  clearFilters: 'Rensa filter',
  discoverExperiences: 'Upptäck upplevelser',
  exclusive: 'Exklusivt',
  experience: 'upplevelse',
  experiencePhotoOfListing:
    'Upplevelsefoto {{photoNumber}} av annons {{listingTitle}}',
  experiences: 'upplevelser',
  filterExperiences: 'Filtrera upplevelser',
  fromListingCard: 'Från',
  hostedBy: 'Värd',
  hostLandingPageTitle: 'Lokala upplevelser',
  hostProductCardTitle: 'Lokala upplevelser',
  hostProductPageTitle: 'Boka lokala upplevelser',
  landingPageTitle: 'Boka unika upplevelser',
  mainLandingPageTitle: 'Alla upplevelser',
  more: 'Mer',
  noExperiencesFound: 'Inga upplevelser hittades',
  noExperiencesFoundFor: 'Inga upplevelser hittades för',
  experiencesFoundCount: '{{count}} upplevelser hittades',
  profileImageOfHost: 'Profilbild av värd {{hostName}}',
  reserve: 'Reservera',
  reserveLandingPageTitle: 'Aktiviteter och bekvämligheter',
  reserveProductCardTitle: 'Aktiviteter',
  reserveProductPageTitle: 'Boka aktiviteter och bekvämligheter',
  resultsPageTitle: 'Boka upplevelser och aktiviteter',
};
